import { render, staticRenderFns } from "./Modal.vue?vue&type=template&id=18990f70"
import script from "./Modal.vue?vue&type=script&lang=js"
export * from "./Modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tomi/Projects/ingeniAR/rrhh/Frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18990f70')) {
      api.createRecord('18990f70', component.options)
    } else {
      api.reload('18990f70', component.options)
    }
    module.hot.accept("./Modal.vue?vue&type=template&id=18990f70", function () {
      api.rerender('18990f70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Workstations/Modal.vue"
export default component.exports